export default function Intro() {
    return (
        <>
            <section className="intro">
                <h1>KamikazeEddi <span>Gaming</span></h1>
            </section>
        </>
    )
}